<template>
  <div class="page-main">
    <el-row>
      <el-col :span="6">
        <h4>可用资源</h4>
      </el-col>
      <el-col :span="6"> </el-col>
    </el-row>
    <div>
      <el-row :gutter="10">
        <el-col :span="6" v-for="(resource, i) in resources" :key="i">
          <el-row :gutter="20" class="index-resource-item">
            <el-col :span="15" align="center">
              <circleProgress v-if="resource.partitionType === 'GPU'" :rate="resource.usedNumber /
                (resource.usedNumber + resource.unUsedNumber)
                " :type="resource.partitionType" :num="resource.partition" style="width: 150px; height: 150px">
              </circleProgress>
              <vueHexagonProgress v-if="resource.partitionType === 'CPU'" :options="hexagonOptions(resource)">
              </vueHexagonProgress>
            </el-col>
            <el-col :span="9">
              <el-descriptions :column="1" style="margin-top: 100%">
                <el-descriptions-item label="已使用">{{
                  resource.usedNumber
                }}</el-descriptions-item>
                <el-descriptions-item label="未使用">{{
                  resource.unUsedNumber
                }}</el-descriptions-item>
              </el-descriptions>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <div>
      <el-row>
        <el-col :span="6">
          <h4>运行作业</h4>
        </el-col>
        <el-col :span="2" :offset="16">
          <el-button class="more-btn" type="text" @click="enterJob(1)">更多...</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" v-for="(item, i) in unFinishedJobs.runningJobsList" :key="i">
          <el-descriptions :column="1" class="index-job-item">
            <el-descriptions-item label="作业ID">{{
              item.jobId
            }}</el-descriptions-item>
            <el-descriptions-item label="已运行时长">{{
              item.runedStrMillis
            }}</el-descriptions-item>
            <el-descriptions-item label="开始时间">{{
              item.startTime | formatDate("yyyy-MM-dd HH:mm:ss")
            }}</el-descriptions-item>
          </el-descriptions>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <h4>排队作业</h4>
        </el-col>
        <el-col :span="2" :offset="16">
          <el-button class="more-btn" type="text" @click="enterJob(2)">更多...</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" v-for="(item, i) in unFinishedJobs.penddingJobsList" :key="i">
          <el-descriptions :column="1" class="index-job-item">
            <el-descriptions-item label="作业ID">{{
              item.jobId
            }}</el-descriptions-item>
            <el-descriptions-item label="等待时长">{{
              item.penddingStrMillis
            }}</el-descriptions-item>
            <el-descriptions-item label="提交时间">{{
              item.submitTime | formatDate("yyyy-MM-dd HH:mm:ss")
            }}</el-descriptions-item>
          </el-descriptions>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <h4>挂起作业</h4>
        </el-col>
        <el-col :span="2" :offset="16">
          <el-button class="more-btn" type="text" @click="enterJob(3)">更多...</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" v-for="(item, i) in unFinishedJobs.suspendJobsList" :key="i">
          <el-descriptions :column="1" class="index-job-item">
            <el-descriptions-item label="作业ID">{{
              item.jobId
            }}</el-descriptions-item>
            <el-descriptions-item label="等待时长">{{
              item.suspendStrMillis
            }}</el-descriptions-item>
            <el-descriptions-item label="挂起时间">{{
              item.suspendTime | formatDate("yyyy-MM-dd HH:mm:ss")
            }}</el-descriptions-item>
          </el-descriptions>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="6">
          <h4>windows作业</h4>
        </el-col>
        <el-col :span="2" :offset="16">
          <el-button class="more-btn" type="text" @click="goWindows(1)">更多...</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" v-for="(item, i) in getWindowsListData" :key="i">

          <el-descriptions :column="1" class="index-job-item">
            <el-descriptions-item label="作业ID">{{
              item.job_id
            }}</el-descriptions-item>
            <el-descriptions-item label="已运行时长">

              {{
                getMillisFn(item.start)
              }}</el-descriptions-item>
            <el-descriptions-item label="开始时间">{{
              item.start | formatDate("yyyy-MM-dd HH:mm:ss")
            }}</el-descriptions-item>
          </el-descriptions>
        </el-col>
      </el-row>

      <h4>概览内容</h4>
      <section>
        <el-descriptions :column="2">
          <el-descriptions-item label="运行中">{{
            unFinishedJobs.runningJobNumber
          }}</el-descriptions-item>
          <el-descriptions-item label="排队中"><span style="color: red">{{
            unFinishedJobs.penddingJobNumber
          }}</span></el-descriptions-item>
          <el-descriptions-item label="挂起中">{{
            unFinishedJobs.suspendJobNumber
          }}</el-descriptions-item>
          <el-descriptions-item label="windows作业数量">{{
            getWindowsListDataTotle
          }}</el-descriptions-item>
        </el-descriptions>
      </section>
    </div>
  </div>
</template>

<script>
import CircleProgress from "../../comm/components/CircleProgress";
import VueHexagonProgress from "vue-hexagon-progress";
export default {
  name: "Index",
  components: {
    circleProgress: CircleProgress,
    vueHexagonProgress: VueHexagonProgress,
  },
  data() {
    return {
      window: window,
      activeIndex: "1",
      resources: [],
      unFinishedJobs: {
        runningJobNumber: undefined,
        penddingJobNumber: undefined,
        suspendJobNumber: undefined,
        penddingJobsList: [],
        runningJobsList: [],
        suspendJobsList: [],
      },
      curTheme: localStorage.getItem('theme') || '',
      getWindowsListData: [],
      getWindowsListDataTotle: 0
    };
  },
  methods: {
    getMillisFn(e) {
      let nowDate = new Date().getTime()

      let startDate = new Date(e).getTime()

      let time = Math.floor((nowDate - startDate) / 1000)
      if (time < 0) return

      //设置单位
      let hourseUnit = '小时'

      let minUnit = '分钟'

      let secUnit = '秒'

      //
      function f_m_dispose(min, sec) {
        if (min < 10 && sec < 10) {
          return "0" + min + minUnit + "0" + sec + secUnit;
        } else if (min < 10 && sec >= 10) {
          return "0" + min + minUnit + sec + secUnit;
        } else if (min >= 10 && sec < 10) {
          return min + minUnit + "0" + sec + secUnit;
        } else {
          return min + minUnit + sec + secUnit;
        }
      }
      let hour = Number.parseInt(time / 3600);
      let min = Number.parseInt((time - hour * 3600) / 60);
      // console.log(min); 
      let sec = time - (hour * 3600) - (min * 60);
      // console.log(sec); 
      if (!hour) {
        return f_m_dispose(min, sec);
      } else {
        // console.log('执行了hour');
        if (!min) {
          // console.log('执行了！min');
          return sec < 10 ? hour + hourseUnit + "00" + minUnit + "0" + sec + secUnit : hour + "小时" + "00" + minUnit + sec + secUnit;
        } else {
          return hour + hourseUnit + f_m_dispose(min, sec);
        }
      }



      // return e
    },
    getWindowsList() {
      let params = {
        size: 4,
        page: 1
      }

      this.http.get("/client/job/userWinGroupJob", { params }).then(res => {
        // console.log(res.data);
        this.getWindowsListDataTotle = res.data.total
        this.getWindowsListData = res.data.res
      })
    },
    goWindows(e) {
      // console.log('windows作业',e);
      this.$store.commit("addActivedMenu", {
        path: "/windowsJob",
        name: "windows作业",
      });
      this.$router.push('/windowsJob')
    },

    hexagonOptions(resource) {
      let primaryColor = "#1C9399";
      let secondaryColor = "#fff";
      let value =
        (resource.usedNumber * 100) /
        (resource.usedNumber + resource.unUsedNumber);
      return {
        width: 150,
        height: 150,
        primaryColor: value != 0 ? primaryColor : secondaryColor,
        secondaryColor: value != 100 ? secondaryColor : primaryColor,
        labelColor: this.curTheme === 'light' ? "#0f243a" : "#fff",
        label: resource.partition,
        value: value,
        className: `hexagon_${resource.partition}`,
        thickness: 80,
        fontSize: 80,
      };
    },
    queryPartitionUsing() {
      this.http.get("/slurm/client/cluster/partition-using").then((res) => {
        // console.log(res);
        if (res && res.data) {
          for (var i = 0; i < res.data.length; i++) {
            const item = res.data[i];
            let usedNumber = 0;
            let unUsedNumber = 0;
            let downNumber = 0;
            if (item.nodeSummaryRs) {
              let totalNumber = parseInt(item.nodes);
              if (item.nodeSummaryRs.down) {
                downNumber = item.nodeSummaryRs.down.nodeCount
                  ? item.nodeSummaryRs.down.nodeCount
                  : 0;
              }
              if (item.nodeSummaryRs.idle) {
                unUsedNumber = item.nodeSummaryRs.idle.nodeCount
                  ? item.nodeSummaryRs.idle.nodeCount
                  : 0;
              }
              usedNumber = totalNumber - unUsedNumber - downNumber;
            }

            this.resources.push({
              partitionType: "CPU",
              usedNumber: Number(usedNumber),
              unUsedNumber: Number(unUsedNumber),
              partition: item.partition,
            });


            // this.resources = [{
            //   partition: "bcores4",
            //   partitionType: "CPU",
            //   unUsedNumber: 41,
            //   usedNumber: 56
            // }, {
            //   partition: "bcores48",
            //   partitionType: "CPU",
            //   unUsedNumber: 13,
            //   usedNumber: 78
            // }, {
            //   partition: "bcores54",
            //   partitionType: "CPU",
            //   unUsedNumber: 40,
            //   usedNumber: 99
            // }, {
            //   partition: "bcores24",
            //   partitionType: "CPU",
            //   unUsedNumber: 10,
            //   usedNumber: 20
            // }, {
            //   partition: "bcores54",
            //   partitionType: "GPU",
            //   unUsedNumber: 0,
            //   usedNumber: 0
            // }, {
            //   partition: "bcores24",
            //   partitionType: "GPU",
            //   unUsedNumber: 0,
            //   usedNumber: 0
            // }]
          }
        }
        // console.log(this.resources);
        //自己修改数据

        // this.resources[0].unUsedNumber = 7
        // this.resources[0].usedNumber = 400
        // console.log(this.resources);
        // this.queryGpuPartitionUsing();
      });
    },
    queryGpuPartitionUsing() {
      this.http
        .get("/slurm/client/cluster/partition-gpu-using", {})
        .then((res) => {
          this.resources = this.resources.concat(res.data);
        });
    },
    queryOwnUnfinishedJob() {
      this.http
        .get("/slurm/client/job/own-unfinished-job?number=8", {})
        .then((res) => {
          // res.data.penddingJobsList = []
          // res.data.runningJobsList = []
          // res.data.suspendJobsList = []
          this.unFinishedJobs = res.data;
        });
    },
    enterJob(type) {
      if (type == 1) {
        this.$store.commit("addActivedMenu", {
          path: "/job",
          name: "运行作业",
        });
        this.$router.push({ path: "/job" });
      } else if (type == 1) {
        this.$store.commit("addActivedMenu", {
          path: "/job",
          name: "运行作业",
        });
        this.$router.push({ path: "/job" });
      } else {
        this.$store.commit("addActivedMenu", {
          path: "/job",
          name: "运行作业",
        });
        this.$router.push({ path: "/job" });
      }
    },
  },
  created() { },
  mounted() {
    this.queryPartitionUsing();
    this.queryOwnUnfinishedJob();
    this.getWindowsList()
  },
};
</script>

<style lang="scss">
.index-resource-item {
  text-align: center;
  // background: rgba(255, 255, 255, 0.1);
  padding: 10px;
  border-radius: 10px;
  margin-right: 20px !important;
  margin-bottom: 20px;

  .el-descriptions__body {
    background: none;
  }
}

.index-job-item {
  margin-bottom: 20px;

  .el-descriptions__body {
    // background: rgba(255, 255, 255, 0.1);
    padding: 10px;
    border-radius: 10px;
  }
}

.more-btn:hover {
  color: #409eff !important;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/workspace/components/Index.vue